import type { ComponentSchema } from '../../../../../schema-types'
import { schema as base } from '../auth/signup.schema'

/** Urban Drip sign-up: the base fields plus the title and the intro line above the phone field. */
export const schema: ComponentSchema = {
  ...base,
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Create account' },
    { key: 'intro', label: 'Intro text', type: 'text', default: 'Create your account with your mobile number.' },
    ...base.commonFields,
  ],
}
